import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

const ALL = "__all__";

export interface FilterSelectProps {
  /** Names the trigger (its accessible name) and, in filter mode, the "All …s" entry. */
  label: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  options: { value: string; label: string }[];
  disabled?: boolean;
  /**
   * Form mode: no "All" entry, and this text shows while nothing is picked.
   * Without it the select is a filter whose empty value means "All <label>s".
   */
  placeholder?: string;
  className?: string;
}

/** A shadcn `Select` over `{value, label}` options: the list's filters and the area forms' pickers. */
export const FilterSelect = ({
  label,
  value,
  onChange,
  options,
  disabled,
  placeholder,
  className,
}: FilterSelectProps) => (
  <Select
    value={value ?? (placeholder === undefined ? ALL : "")}
    onValueChange={(v) => onChange(v === ALL ? undefined : v)}
    disabled={disabled}
  >
    <SelectTrigger
      aria-label={label}
      className={cn("h-8 w-[160px]", className)}
    >
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {placeholder === undefined && (
        <SelectItem value={ALL}>{`All ${label.toLowerCase()}s`}</SelectItem>
      )}
      {options.map((o) => (
        <SelectItem key={o.value} value={o.value}>
          {o.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
